import React from "react";
import styled from "styled-components";
const Stars = (props) => {
  const Icon = styled.i`
    color: ${window.lrmSettings["primary"]};
  `;
  let starCount = "";
  if (props.starCount === 5) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
      </>
    );
  }
  if (props.starCount === 4) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }

  if (props.starCount >= 3 && props.starCount < 4) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  if (props.starCount >= 2 && props.starCount < 3) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  if (props.starCount >= 1 && props.starCount < 2) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  if (props.starCount === 0) {
    return "";
  }
  if (props.agg) {
    return <p className="lrm-reviews-star-count">{starCount}</p>;
  }
  return (
    <p className="lrm-reviews-star-count">
      {props.starCount}/5 {starCount}
    </p>
  );
};

export default Stars;
